import type { ActivityLogicPlugin } from '../../core/types/plugin.base.types';
import type { FractionModelPayload, FractionModelRuntime } from '../../core/types/payloads/fraction_model.types';
import type { HostActionPayload, StudentInputEnvelope } from '../../core/types/events.types';
import type { RoutingMode } from '../../core/types/room.types';
import { FractionModelPayloadSchema } from '../../core/schemas/examGenerationSchema';

export function validateFractionModelPayload(raw: unknown): FractionModelPayload {
  const parsed = FractionModelPayloadSchema.safeParse(raw);
  if (!parsed.success) {
    const first = parsed.error.issues[0];
    throw new Error(first?.message || 'FractionModel payload invalid');
  }

  const data = parsed.data;
  return {
    instruction: data.instruction.trim(),
    numerator: data.numerator,
    denominator: data.denominator,
    visualType: data.visualType,
  };
}

export function createInitialFractionModelRuntime(
  _payload: FractionModelPayload,
  _routing: RoutingMode,
): FractionModelRuntime {
  return { viewed: false };
}

export const fractionModelLogic: ActivityLogicPlugin<'fraction_model'> = {
  mode: 'fraction_model',
  validatePayload: validateFractionModelPayload,
  createInitialRuntime: createInitialFractionModelRuntime,

  onStudentInput(ctx, input: StudentInputEnvelope) {
    if (input.action === 'EXAM_CONTINUE' || input.action === 'VIEW') {
      return { runtime: { ...ctx.runtime, viewed: true } };
    }
    return { runtime: ctx.runtime, rejected: true, rejectReason: 'UNKNOWN_ACTION' };
  },

  onHostAction(ctx, _action: HostActionPayload) {
    return { runtime: ctx.runtime };
  },
};

export function demoFractionModelPayload(): FractionModelPayload {
  return validateFractionModelPayload({
    instruction: 'Observa la fracción sombreada y escribe cuántas partes del total están coloreadas.',
    numerator: 3,
    denominator: 8,
    visualType: 'bar',
  });
}
